import { Component, OnInit, Input, ViewChild, ComponentFactoryResolver,
   AfterViewInit, ReflectiveInjector } from '@angular/core';
import { FcnavtabcontentDirective } from './fcnavtabcontent.directive';
import { ParentBusiness } from 'fccore2';
/**
 * Componentç»ä»¶æ¨¡æ¿
 * ng-template åç´ æ¯å¨æå è½½ç»ä»¶çæä½³éæ©ï¼å ä¸ºå®ä¸ä¼æ¸²æä»»ä½é¢å¤çè¾åº
 * tab-host å¨è¿éå¾å°åºç¨
 */
@Component({
  selector: "fcnavtabtpl",
  template: `<ng-template fcnavtabcontent></ng-template>`
})
export class FcnavtabtplComponent implements OnInit, AfterViewInit {
  currentComponent = null; // å½åçç»ä»¶
  @Input() tab: any; // éè¦å¨æå è½½ç»ä»¶
  @ViewChild(FcnavtabcontentDirective, { static: false })
  tabHost: FcnavtabcontentDirective;
  constructor(private componentFactoryResolver: ComponentFactoryResolver) {}
  ngOnInit() {}
  ngAfterViewInit() {
    // this.loadComponent();
    setTimeout(() => {
      // this.loadAndPassParams();
      this.loadComponent();
    }, 0);
  }
  /**
   * å è½½ç»ä»¶ï¼ä¸æ¶ååæ°ä¼ é
   */
  loadComponent() {
    let componentFactory;
    if (ParentBusiness.lazyService.loadModules[this.tab.module]) {
      componentFactory = ParentBusiness.lazyService.loadModules[this.tab.module].componentFactoryResolver.resolveComponentFactory(this.tab.component);
    } else {
      componentFactory = this.componentFactoryResolver.resolveComponentFactory(
        this.tab.component
      );
    }
    const viewContainerRef = this.tabHost.viewContainerRef;
    const componentRef = viewContainerRef.createComponent(componentFactory);
    // tslint:disable-next-line:no-string-literal
    componentRef.instance['routerParam'] = (this.tab.data === undefined ? {} : (this.tab.data.param === undefined ? {} : this.tab.data.param));
  }
  /**
   * å è½½ç»ä»¶ï¼ä¸æ¶ååæ°ä¼ é
   *
   */
  loadComponent0() {
    // console.log(this.tab);
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(
      this.tab.component
    );
    const viewContainerRef = this.tabHost.viewContainerRef;
    const componentRef = viewContainerRef.createComponent(componentFactory);
  }
  /**
   * å è½½ç»ä»¶ï¼ä½¿ç¨ReflectiveInjectoræ³¨å¥åæ°
   */
  loadAndPassParams() {
    if (!this.tab.data) {
      // å¦ææ²¡æä¼ åï¼é»è®¤ç»ä¸ä¸ªç©ºå¯¹è±¡
      this.tab.data = {};
    }
    const inputProviders = Object.keys(this.tab.data).map(inputName => {
      return {
        provide: inputName,
        useValue: this.tab.data[inputName]
      };
    });
    const resolvedInputs = ReflectiveInjector.resolve(inputProviders);
    // We create an injector out of the data we want to pass down and this components injector
    const dynamicComponentContainer = this.tabHost.viewContainerRef;
    const injector = ReflectiveInjector.fromResolvedProviders(
      resolvedInputs,
      dynamicComponentContainer.parentInjector
    );
    // We create a factory out of the component we want to create
    const factory = this.componentFactoryResolver.resolveComponentFactory(
      this.tab.component
    );
    // We create the component using the factory and the injector
    const component = factory.create(injector);
    // We insert the component into the dom container
    dynamicComponentContainer.insert(component.hostView);
    // We can destroy the old component is we like by calling destroy
    if (this.currentComponent) {
      this.currentComponent.destroy();
    }
    this.currentComponent = component;
  }
}
